import { useGetApiV1LocationCountriesCountryidLangs } from '@/shared/api/generated';

/**
 * Tamanho de página usado na paginação **client-side** da listagem de Idiomas.
 *
 * TODO: remover a paginação client-side quando o backend implementar paginação
 * server-side em `GET /api/v1/location/countries/{countryId}/langs`. Hoje o
 * endpoint retorna a lista COMPLETA (sem `page`/`pageSize`/`total`), então
 * fatiamos no front. Quando o backend suportar: enviar `page`/`pageSize` e usar
 * os totais do envelope (ver `src/pages/_authenticated/location/countries/$countryId/langs`).
 */
export const COUNTRY_LANG_PAGE_SIZE = 10;

/**
 * Hook para listar os idiomas de um país.
 *
 * Envolve `GET /api/v1/location/countries/{countryId}/langs` (lista completa, sem
 * paginação/busca server-side). Deriva `countryName` do primeiro item quando há
 * dados (evita uma chamada extra a `GET /countries/{id}`).
 *
 * @param countryId - Id do país.
 */
export function useCountryLangList(countryId: number) {
  const query = useGetApiV1LocationCountriesCountryidLangs(countryId);
  const langs = query.data ?? [];

  return {
    langs,
    countryName: langs[0]?.countryName ?? '',
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  } as const;
}
